/* components/AccordionBody.ts

Accordion Body Component
sets the body height for when the accordion is open so animation is nice
*/

import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AccordionBody extends ThemeComponent {

    @Prop bypassAnimation!: boolean;

    init() {
        const height = this.bypassAnimation ? 'auto' : `${this.scrollHeight + 20}px`;
        this.style.height = height;
    }
}
